<template>
  <b-modal id="register-success-modal" modal-class="modal-style" ref="modal">
    <template>
      <p class="modal-style-title not-one-row">
        {{ showMemberPhone }} 註冊成功
      </p>
      <div class="modal-style-content">
        <p class="modal-style-content__mobile">密碼預設為西元生日8碼</p>
        <p>歡迎登入APP，享用更便利的服務</p>
      </div>
    </template>

    <template v-slot:modal-footer>
      <button class="custom-btn modal-style-single-btn" @click="refreshPage()">
        確認
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    phone: {
      type: String,
      required: true,
      default() {
        return '';
      }
    }
  },
  computed: {
    showMemberPhone() {
      let substring = this.phone.substring(4, 7);

      return this.phone.replace(substring, '***');
    }
  },
  methods: {
    refreshPage() {
      this.$bvModal.hide('register-success-modal');
      location.reload();
    }
  }
};
</script>
